import AppHeader from '../AppHeader'
import MasterComsumableItemInput from '../MasterComsumableItemInput'

export default {
  name: 'master-consumable-item-new',
  async created () {
    await this.getCategory()
    await this.getSupplier()
    this.isShow = true
  },
  data () {
    return {
      consumableItem: {
        name: '',
        name_hurigana: '',
        product_code: '',
        category_id: '',
        supplier_id: '',
        lot_price: '',
        unit: '',
        size: '',
        lot_number: '',
        is_can_order: true,
        remark: '',
        image: ''
      },
      categories: [],
      suppliers: [],
      displayImageUrl: '',
      isShow: false
    }
  },
  components: {
    AppHeader,
    MasterComsumableItemInput
  },
  methods: {
    onFileChange (event) {
      const file = event.target.files || event.dataTransfer.files
      this.consumableItem.image = file[0]
      this.upload(file[0])
    },
    upload: function (file) {
      const reader = new FileReader()
      const self = this
      reader.onload = (e) => {
        self.displayImageUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    deleteFile () {
      this.consumableItem.image = ''
      this.displayImageUrl = ''
    },
    async getCategory () {
      let data = {}
      let res = await this.$store.dispatch('GET_CATEGORY_LIST', {data: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.categories = res.categories
    },
    async getSupplier () {
      let data = {}
      let res = await this.$store.dispatch('GET_SUPPLIER_LIST', {data: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.suppliers = res.suppliers
    },
    async createConsumableItem (formData) {
      formData.append('image', this.consumableItem.image)
      await this.$store.dispatch('CONSUMABLE_ITEM_CREATE', {data: formData})
                        .catch(err => {
                          console.log(err)
                          return
                        })
      this.$router.push('/master_consumable_item_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-consumable-item-new.js